<div class="outer-container" [hidden]="isBypass || isLoggedIn" [ngClass]="{'refreshing': isBypass || isLoggedIn }">
    <div class="left-panel">
        <span class="heading">{{'ARC_COMPOSITE_LOGIN_HEADING' | translate}}</span>
        <span class="body-lg subheading">{{'ARC_COMPOSITE_LOGIN_SUBTEXT' | translate}}</span>
    </div>

    <div class="right-panel">
        <div class="header-logo">
            <div class="logo"></div>
        </div>
        <div class="login-form">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>